export default class Password {
    constructor(elm) {

        const togglePassword = elm.querySelector('#toggle-password');
        const password = elm.querySelector('#id-password');
        const passwordIcon = elm.querySelector(".svg-icon__eye");
        const passwordIconSlash = elm.querySelector(".svg-icon__eye-slash");

        togglePassword.addEventListener('click', () => {
            const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
            password.setAttribute('type', type);

            if (passwordIconSlash.style.display == 'block') {
                passwordIconSlash.style.display = 'none';
                passwordIcon.style.display = 'block';
            }
            else {
                passwordIconSlash.style.display = 'block';
                passwordIcon.style.display = 'none';
            }
        });
    }
}
